import { StringCase, ValueOf, asCase } from '@converge/utils';
import { ReactNode, useMemo } from 'react';

export interface IUseAsCaseOptions {
  casing?: StringCase | ValueOf<StringCase>;
  allowNonStrings?: boolean;
  enabled?: boolean;
  value: ReactNode;
  transformBefore?: (find: string) => string;
  transformAfter?: (find: string) => string;
}

export const useAsCase = ({
  value,
  casing = StringCase.Sentence,
  allowNonStrings = false,
  enabled = true,
  transformBefore,
  transformAfter,
}: IUseAsCaseOptions) => {
  return useMemo(() => {
    if (!enabled) {
      return value;
    }

    let newValue: string;

    if (typeof value !== 'string') {
      newValue = String(value);
    } else {
      newValue = value;
    }

    if (transformBefore) {
      newValue = transformBefore(newValue);
    }

    newValue = asCase(newValue, casing, allowNonStrings);

    if (transformAfter) {
      newValue = transformAfter(newValue);
    }

    return newValue;
  }, [
    enabled,
    value,
    transformBefore,
    casing,
    allowNonStrings,
    transformAfter,
  ]);
};
